import { Text, View, Image } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { numberToWords } from '../../utils/numberToWords';
import AuthorizedSignature from '../../assets/images/dummy_signature.png'
import ImageAsBase64 from '../../utils/imageToBase64';
import { calculateRoundOff } from '../../utils/calculateRoundOff';

const MainFooter = ({ totals, taxBreakup, transactionType, signatureData }) => {

  const transactionMode = 'Inter State';

  const RUPEE_SYMBOL = '\u20B9';

  // const [signatureData, setSignatureData] = useState(null);

  // Load signature on component mount
  // useEffect(() => {
  //   const loadSignature = async () => {
  //     try {
  //       // Replace with your actual signature path
  //       const base64Signature = await ImageAsBase64(AuthorizedSignature);
  //       setSignatureData(base64Signature);
  //     } catch (error) {
  //       console.error('Error loading signature:', error);
  //     }
  //   };

  //   loadSignature();
  // }, []);

  return (
    <View style={{ border: '1px solid black' }}>
      <Text style={{ fontSize: '8px', fontWeight: 'extrabold', padding: 5 }}>REMARK : </Text>
      <View style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid black' }}>
        <View style={{ flex: 1, borderRight: '1px solid black', justifyContent: 'center' }}>
          <View style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid black', borderBottom: '1px solid black', paddingVertical: 5, paddingHorizontal: 2 }}>
            <Text style={{ flex: 1, fontWeight: 800, fontSize: '8px' }}>Total Quantity: {totals.totalQuantity}</Text>
            <Text style={{ flex: 1, fontWeight: 800, fontSize: '8px' }}>Total Items: {totals.totalItems}</Text>
          </View>
        </View>

        <View style={{ flex: 3, display: 'flex', flexDirection: 'column', height: 90 }}>
          <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <View style={{ flex: 2, display: 'flex', flexDirection: 'column' }}>
              <View style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px solid black' }}>
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>GST slab</Text>
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{`Total`}</Text>
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{`Disc.`}</Text>
                {transactionType() == 'Intra State' &&
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{`sgst`}</Text>
                }
                {transactionType() == 'Intra State' &&
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{'cgst'}</Text>
                }
                {transactionType() == 'Inter State' &&
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{'Igst'}</Text>
                }
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{'Total GST'}</Text>
              </View>
              {Object.entries(taxBreakup).map(([slab, values]) => (
                <View key={slab} style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px solid black' }}>
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>{slab.replace('slab', '')}%</Text>
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{values.baseAmount.toFixed(2)}</Text>
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{parseFloat(values.discount).toFixed(2)}</Text>
                  {transactionType() == 'Intra State' &&
                    <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{values.sgst.toFixed(2)}</Text>
                  }
                  {transactionType() == 'Intra State' &&
                    <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{values.cgst.toFixed(2)}</Text>
                  }
                  {transactionType() == 'Inter State' &&
                    <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{values.igst.toFixed(2)}</Text>
                  }
                  <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{values.total.toFixed(2)}</Text>
                </View>
              ))}
            </View>

            <View style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>SUB TOTAL</Text>
                <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + totals.subTotal.toFixed(2)}</Text>
              </View>
              <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>Discount</Text>
                <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + parseFloat(totals.totalDiscount).toFixed(2)}</Text>
              </View>
              {transactionType() == 'Intra State' &&
                <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>Total SGST</Text>
                  <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + totals.totalSGST.toFixed(2)}</Text>
                </View>
              }
              {transactionType() == 'Intra State' &&
                <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>Total CGST</Text>
                  <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + totals.totalCGST.toFixed(2)}</Text>
                </View>
              }
              {transactionType() == 'Inter State' &&
                <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>IGST PAYABLE</Text>
                  <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + totals.totalIGST.toFixed(2)}</Text>
                </View>
              }
              <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, paddingLeft: 2 }}>Round Off</Text>
                <Text style={{ fontSize: '7px', fontWeight: 500, paddingRight: 5 }}>{RUPEE_SYMBOL + ' ' + calculateRoundOff(totals.grandTotal)}</Text>
              </View>
            </View>
          </View>

          <View style={{ borderTop: '1px solid black', display: 'flex', flexDirection: 'row' }}>
            <View style={{ flex: 2, display: 'flex', flexDirection: 'row' }}>
              <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'center', padding: '0.65%' }}>TOTAL</Text>
              <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{totals.subTotal.toFixed(2)}</Text>
              <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{parseFloat(totals.totalDiscount).toFixed(2)}</Text>
              {transactionType() == 'Intra State' &&
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{totals.totalSGST.toFixed(2)}</Text>
              }
              {transactionType() == 'Intra State' &&
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{totals.totalCGST.toFixed(2)}</Text>
              }
              {transactionType() == 'Inter State' &&
                <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{totals.totalIGST.toFixed(2)}</Text>
              }
              <Text style={{ flex: 1, borderRight: '1px solid black', fontSize: '8px', textTransform: 'uppercase', textAlign: 'right', padding: '0.65%' }}>{totals.totalTax.toFixed(2)}</Text>
            </View>
            <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
              <Text style={{ flex: 1, fontSize: '7px', fontWeight: 1000, padding: 2 }}>GRAND TOTAL</Text>
              <Text style={{ fontSize: '7px', fontWeight: 1000, textTransform: 'uppercase', padding: '0.65%' }}>{RUPEE_SYMBOL + ' ' + parseFloat(parseInt(totals.grandTotal, 10)).toFixed(2)}</Text>
            </View>
          </View>
        </View>
      </View>
      <View style={{ borderTop: '1px solid black', display: 'flex', flexDirection: 'row', padding: 5, justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ padding: 2, fontWeight: 800, fontSize: '10px', textTransform: 'capitalize' }}>Amount To Be Paid (in words)  : Indian Rupees {numberToWords(parseInt(totals.grandTotal, 10))} Only</Text>
        <Text style={{ padding: 2, fontWeight: 800, fontSize: '8px', textTransform: 'capitalize' }}>Invoice Amount :{RUPEE_SYMBOL + ' ' + parseFloat(totals.grandTotal).toFixed(2)}</Text>
      </View>
      <View style={{ borderTop: '1px solid black', padding: 5, display: 'flex', flexDirection: 'row' }}>
        <View style={{ flex: 2 }}>
          <Text style={{ fontSize: '9px', fontWeight: 1000 }}>Terms & Conditions</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>1. This is a one-time, non-refundable registration fee for onboarding and access to the CuDel platform.</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>2. No physical goods are provided.</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>3. GST is charged as per applicable laws.</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>4. This does not guarantee bookings or earnings.</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>5. Access is non-transferable and valid for one expert only. Disputes are subject to Uttar Pradesh jurisdiction.</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ fontSize: '9px', fontWeight: 1000 }}>Banking Details</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>Account Holder: CUDEL DELIGHT SOLUTIONS PRIVATE LIMITED</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>Account No: 003105501659</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>IFSC Code: ICIC0000031</Text>
          <Text style={{ fontSize: '6px', fontWeight: 1000 }}>Branch: SENIOR MALL Sec 18 Branch, Noida, UP</Text>
        </View>
        <View style={{}}>
          <Text style={{ fontSize: '9px', fontWeight: 1000 }}>For Cudel Delight Solutions Pvt. Ltd.</Text>
          {/* <View style={{height:'15px'}}></View> */}
          <View style={{ padding: 2, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            {signatureData && (
              <Image
                style={{ width: 100, height: 30, marginRight: 20, objectFit: 'contain' }}
                src={signatureData}
              />
            )}
          </View>
          <Text style={{ fontSize: '6px', fontWeight: 1000, alignSelf: 'center' }}>Authorized Signatory</Text>
        </View>
      </View>
    </View >
  );
};

export default MainFooter;